import { ComplaintStatusEnum } from "@ryde/shared";
import { greyMui, indigoMui, redMui, rydeColors } from "@ryde/theme";

export interface IStatusIndicatorComplaint {
  status: ComplaintStatusEnum | null | undefined;
  fontSize?: string;
}

export interface IStatusIndicatorComplaintControl {
  $bgColor: string;
  $leftColor: string;
  color: string;
  $translateKey: string;
  $dataE2eValue?: string;
  fontSize?: string;
}

export const StatusIndicatorComplaintConst: Record<
  ComplaintStatusEnum,
  IStatusIndicatorComplaintControl
> = {
  [ComplaintStatusEnum.Canceled]: {
    $bgColor: redMui.A200,
    $leftColor: redMui._900,
    color: rydeColors.white,
    $translateKey: "Canceled",
    $dataE2eValue: "Canceled",
  },
  [ComplaintStatusEnum.Closed]: {
    $bgColor: greyMui._100,
    $leftColor: greyMui._300,
    color: greyMui._500,
    $translateKey: "Closed",
    $dataE2eValue: "Closed",
  },
  [ComplaintStatusEnum.New]: {
    $bgColor: indigoMui._50,
    $leftColor: indigoMui._600,
    color: rydeColors.black,
    $translateKey: "New",
    $dataE2eValue: "New",
  },
  [ComplaintStatusEnum.Pending]: {
    $bgColor: greyMui._100,
    $leftColor: greyMui._300,
    color: greyMui._500,
    $translateKey: "Pending",
    $dataE2eValue: "Pending",
  },
};
